import { Tag, Text } from "@/elements"
import { MetadataSectionContainer } from "./MetadataSectionContainer"

interface Props {
  title: string
  tags: string[]
  isEditing?: boolean
  onEditClick?: () => void
}

export const TagsMetadataSection: React.FC<Props> = ({ title, tags = [], isEditing, onEditClick }) => {
  return (
    <MetadataSectionContainer title={title} isEditing={isEditing} onEditClick={onEditClick}>
      <div className="flex flex-row flex-wrap gap-2">
        {tags.map(tag => {
          return (
            <div key={tag} className="">
              <Tag text={tag} />
            </div>
          )
        })}
      </div>
    </MetadataSectionContainer>
  )
}
